<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask" :class="{ 'landing-experiencia': !!styleVars }" :style="styleVars">
      <div class="modal-container" :style="{ minWidth: minWidth }">
        <div class="d-flex align-items-center w-100">
          <div class="modal-nav">
            <slot name="backAction" class="text-start" />
          </div>
          <div class="modal-title">
            <slot name="header">
              <span class="text-start title h6" :class="styleVars ? 'text-landing semibold' : ''">{{ title }}</span>
            </slot>
          </div>
          <div v-if="!hideClose" class="modal-close mt-1">
            <button type="button" class="btn-close-icon text-end" @click="$emit('onClose')">
              <CustomIcon :icon="crossIcon" size="14px" />
            </button>
          </div>
        </div>

        <div class="modal-body">
          <slot name="body">default body</slot>
        </div>

        <div class="modal-footer" :style="`justify-content :${alignFooter} `">
          <slot name="footer">
            <MyGocuButton
              v-if="!hideCancel"
              secondary
              :label="cancelText"
              @click="
                $emit('onClose');
                $emit('onCancel');
              " />
            <MyGocuButton
              v-if="!hideSubmit"
              primary
              :label="submitText"
              @click="
                $emit('onClose');
                $emit('onSubmit');
              " />
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
  import CustomIcon from '@/components/CustomIcon.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import crossIcon from '@/assets/icons/cross.svg';

  defineProps({
    show: Boolean,
    title: {
      type: String,
      default: null,
    },
    hideSubmit: {
      type: Boolean,
      default: false,
    },
    submitText: {
      type: String,
      default: 'Accept',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    alignFooter: {
      validator(value) {
        return ['left', 'center', 'right'].includes(value);
      },
      default: 'right',
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: '70vw',
    },
    styleVars: {
      type: Object,
      default: null,
    },
  });

  defineEmits(['onClose', 'onSubmit', 'onCancel']);
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--bs-black-rgb), 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    max-width: 600px;
    margin: auto;
    padding: 20px 30px;
    background-color: var(--landing-background-color, var(--bs-white));
    box-shadow: 0 2px 8px rgba(var(--bs-black-rgb), 0.33);
    transition: all 0.3s ease;
    border-radius: var(--bs-border-radius-xl);

    @media only screen and (max-width: 768px) {
      padding: 20px 15px;
      max-width: 95%;
    }
  }

  .modal-footer {
    border-top: none !important;
  }

  .modal-body {
    margin: 20px 0;
    max-height: 79vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      /* //margin: auto 0.5rem; */
      width: 95%;
    }
  }

  .modal-nav,
  .modal-title,
  .modal-close {
    flex: 0 0 auto;
  }

  .modal-title {
    flex: 1;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding-right: 0.5rem;
  }

  .btn-close-icon {
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--landing-text-color, var(--bs-primary));
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
</style>
